<template>
    <div>
        <div>
            <label class="file-upload">
                <span>Upload</span>
                <input
                        type="file"
                        class="form-controlopopo"
                        @change="onFileChange"
                        placeholder="Choose File"
                        name="files"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                >
            </label>

            <div v-if="document">
                <div class="images-lists col-lg-12 col-md-12">
                    <a href="javascript:void(0)">{{document.name}}</a>
                    <div class="cross-btn" @click="document = null"></div>
                </div>
            </div>

            <div>
                <div class="col-lg-12 col-md-12">
                    <button
                            type="submit"
                            @click.prevent="uploadStart()"
                            class="btn btn-sm btn-elevate btn-brand"
                            :disabled="disableButton"
                    >{{disableButton ? 'Submitting...' : 'Import'}}
                    </button>
                </div>
            </div>
        </div>
        <div>
            <div class="col-lg-12 col-md-12">
                <button
                        type="button"
                        @click="downloadStart()"
                        class="btn btn-sm btn-elevate btn-brand"
                        :disabled="disableDownloadButton"
                >{{disableDownloadButton ? 'downloading...' : 'Export'}}
                </button>
            </div>
        </div>
    </div>
</template>


<script>
    import Vue from "vue";
    import VeeValidate from "vee-validate";
    import swal from "sweetalert2";
    import axios from "axios";

    export default {
        mounted() {
            console.log("upload csv");
        },
        props: ['category', 'categoryLevel'],
        data() {
            return {
                disableButton: false,
                disableDownloadButton: false,
                document: null,
                listData: this.data,
                type: 'product'
            };
        },
        watch: {
            data(value) {
                this.listData = value;
            }
        },

        methods: {

            uploadStart() {


                console.log(process.env.MIX_API_URL);
                if (this.disableButton) {
                    return;
                }

                if (!this.document) {
                    swal("Oops!", "No file selected", "error");
                    return;
                }

                this.disableButton = true;
                axios
                    .post(process.env.MIX_API_URL + "/upload/" + this.type + "/csv", {
                        document: this.document
                    })
                    .then(response => {
                        console.log(response.status);
                        this.document = null;
                        this.disableButton = false;

                        swal("Success", "Uploaded Successfully", "success");

                        // let currentPageUrl = window.location.href;
                        //
                        // window.location.href = currentPageUrl;

                    })

            },

            downloadStart() {
                if (this.disableDownloadButton) {
                    return;
                }
                this.disableDownloadButton = true;

                axios.post(process.env.MIX_API_URL + "/download/" + this.type + "/csv", {
                    data: this.listData,
                    category_id: this.category,
                    category_level: this.categoryLevel,

                })
                    .then(response => {

                            this.disableDownloadButton = false;
                            let productName = response.data;
                            if (productName == 'mail') {

                                swal("Success", "File Link will be mailed to you within 20 minutes", "success");
                                // swal("Success", "download Complete", "success");

                            } else {
                                let targetUrl = this.url + '/storage/' + productName;
                                swal("Success", "download Complete", "success");
                                window.location.href = targetUrl;
                            }


                            // if (this.category == null) {
                            //     let currentPageUrl = window.location.href;
                            //
                            //     window.location.href = currentPageUrl;
                            // }

                        }
                    )
                    .catch(errors => {
                        this.disableDownloadButton = false;
                        this.error = errors.response;
                        // swal("Error", this.error, "error");
                    });
            },

            onFileChange(e) {
                let files = e.target.files || e.dataTransfer.files;
                let vim = this;
                for (var i = 0; i < files.length; i++) {
                    (function (file) {
                        var name = file.name;
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            vim.document = {
                                name,
                                data: e.target.result,
                                type: file.type,
                                size: file.size
                            };
                        };

                        reader.readAsDataURL(file);
                    })(files[i]);
                }
            }
            ,

            onDrop: function (e) {
                e.stopPropagation();
                e.preventDefault();
                this.onFileChange(e);
            }
            ,

            removeDocument(index) {
                this.$delete(this.documents, index);
            }
        },
        computed: {
            category_id() {

                let key = "filter";
                return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            }
            ,
            url: function () {
                return process.env.MIX_MAIN_URL;
            },
        }
    }
    ;
</script>


